module.exports = __webpack_public_path__ + "img/UTGOBL-1.fdc368a2.jpg";